module.exports = __webpack_public_path__ + "img/image2.bd19ab96.png";